
import { defineComponent } from 'vue'
import EnrolmentList from '@/components/enrolment/list/EnrolmentList.vue'

export default defineComponent({
  components: { EnrolmentList },
})
